module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "emilia-afrange-square.9cd7d3be.png" + "?" + Date.now();